import React, { useState, useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "@/services/hooks";
// GET all sites
import { getSites } from "@/services/siteServices/siteActions";
import {
  patchProduct,
} from "@/services/productServices/productActions";

import { Link } from "react-router";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Label,
  FormGroup,
  InputGroup,
  InputGroupText,
  Form,
  Input,
} from "reactstrap";
import classnames from "classnames";
import { changeLinkedValue } from "./changeLinkedValue";

export type LinkedSitesProps = {
  /** the product document as UpdateProductContainer holds it (its state is `any`, translated from JSDoc) */
  product: any; // any: the product document from UpdateProductContainer state; productSlice types product_byId as any (productSlice.ts:48)
};

function LinkedSites(props: LinkedSitesProps) {
  const dispatch = useAppDispatch();
  const sites = useAppSelector((state) => state.sites.sites);
  const [Product, setProduct] = useState<any>({}) // any: local copy of that product document (linked[] edited here); no client Product type yet
  const [loading, setLoading ] = useState(false)

  useEffect( () => {
    if (sites.length === 0) {
      dispatch(getSites());
    }
    if(props.product.linked){
        setProduct(props.product)
    }
    // NOTE: this effect used to also upload props.product.productImg to Cloudinary when a
    // fresh image was picked. That was legacy `componentWillReceiveProps` logic — the
    // product image is now owned by UpdateProductContainer (its "Update Product" button /
    // useImageUpload, SCRUM-913). Because it depended on imageUrl (state.images.url) yet
    // guarded on props.product.productImg.data — which a successful upload never clears —
    // each QUOTE_RECEIVED re-ran the effect and re-uploaded in a loop, and a failed upload
    // (uploadImageAction re-throws since SCRUM-815) escaped as an unhandled rejection. It is
    // removed here so LinkedSites only edits per-site linked[] values (follow-up to
    // SCRUM-913; this stray upload was found while migrating the container onto useImageUpload).
  }, [sites.length, props.product]);


  const changeParams = (e, siteID) => {
    setProduct({
      ...Product,
      linked: changeLinkedValue(Product.linked, siteID, e.target.name, e.target.value),
    });
  };

  const updateLinkedSites = () => {
    // SCRUM-1447: send only the fields this button changes, not the whole product. The
    // patch route assigns every key it receives (server/controllers/product.js,
    // `addProductToSite`), so anything else in the body is a stale copy from the loaded
    // page waiting to overwrite a concurrent change — measured on `active`, which is no
    // longer shown anywhere since SCRUM-312 and so moved invisibly.
    //
    // This replaces an earlier `delete prodState.productImg`, which excluded exactly one
    // field for the same reason: a freshly-picked, not-yet-uploaded raw file object
    // ({ data, imgName }) must never be written onto product.productImg. An allowlist
    // keeps that guarantee and extends it to every other field at once.
    //
    // `linked` is what this screen edits (changeParams rebuilds it). `client` is here
    // because the handler coerces an absent client to null and then writes it, so
    // omitting it would clear the product's client on every save. Same four fields, and
    // the same reasoning, as UpdateProductContainer's link toggle.
    const payload = {
      _id: Product._id,
      linked: Product.linked,
      __v: Product.__v,
      client: Product.client,
    }
    // patchProduct re-throws on failure (SCRUM-815); swallow here since this flow has no
    // post-dispatch action and feedback comes from the store message effect.
    dispatch(patchProduct(payload)).catch(() => {})
  }

  if (Product.linked && Product.linked.length > 0 && sites.length >0) {
    return (
      <>
        <Row>
            <Col>
            {[...Product.linked].sort((a,b) => (a.siteid > b.siteid) ? 1 : ((b.siteid > a.siteid) ? -1 : 0)).map(
                (linkedSite) => {
                    // SCRUM-1403: a stored entry can name a site `getSites()` does not
                    // return — a soft-deleted one, for instance. `filter(...)[0]` is then
                    // `undefined`, and reading `.domain` off it threw and blanked the whole
                    // screen. Same defect and same fix as SCRUM-1401 on the label screen;
                    // this file is where that code was copied from.
                    //
                    // The entry is RENDERED, not skipped. `changeParams` rebuilds `linked[]`
                    // from what is in state and `updateLinkedSites` posts that, so dropping
                    // it here would delete another tenant's link on the next Update — the
                    // silent-loss shape SCRUM-1357 and SCRUM-1359 already cost this repo.
                    const linkedSiteDoc = sites.find((site) => site._id === linkedSite.siteid)
                    return(
                        <div key={linkedSite.siteid}>


                        <Card>
                        <CardHeader>
                          <h4>{linkedSiteDoc ? linkedSiteDoc.domain : `Unknown site (${linkedSite.siteid})`}</h4>
                        </CardHeader>
                        <CardBody>

                            {/* TITLE */}
                            
                      <FormGroup className="row">
                        <Label
                          className="form-control-label"
                          htmlFor="example-text-input"
                          md="1"
                        >
                          Title
                        </Label>
                        <Col md="9">
                          <InputGroup className={classnames("input-group-merge")}>
                            
                              <InputGroupText>
                                <i className="ni ni-box-2" />
                              </InputGroupText>
                            <Input
                              placeholder="Insert Product Title"
                              name="title"
                              type="text"
                            defaultValue={linkedSite.value.title}
                              onChange= {(e)=>changeParams(e, linkedSite.siteid)}
                            //   onChange={this.onChange.bind(this)}
                            //   invalid={!this.state.validation.title}
                            />
                          </InputGroup>
                          </Col>
                      </FormGroup>
                            {/* Clikout url  */}
                            <FormGroup className="row">
                        <Label
                          className="form-control-label"
                          htmlFor="example-text-input"
                          md="1"
                        >
                          Click URL
                        </Label>
                        <Col md="9">
                          <InputGroup className={classnames("input-group-merge")}>
                            
                              <InputGroupText>
                                <i className="ni ni-box-2" />
                              </InputGroupText>
                            <Input
                              placeholder="Insert Product Click out URL"
                              name="clickOutUrl"
                              type="text"
                              defaultValue={linkedSite.value.clickOutUrl}
                              onChange= {(e)=>changeParams(e, linkedSite.siteid)}
                            //   onChange={this.onChange.bind(this)}
                            //   invalid={!this.state.validation.title}
                            />
                          </InputGroup>
                          </Col>
                      </FormGroup>
                            {/* discount */}
                            <FormGroup className="row">
                        <Label
                          className="form-control-label"
                          htmlFor="example-text-input"
                          md="1"
                        >
                          Promotion
                        </Label>
                        <Col md="9">
                          <InputGroup className={classnames("input-group-merge")}>
                            
                              <InputGroupText>
                                <i className="ni ni-box-2" />
                              </InputGroupText>
                            <Input
                              placeholder="Insert Product Discount"
                              name="discount"
                              type="text"
                              defaultValue={linkedSite.value.discount }
                              onChange= {(e)=>changeParams(e, linkedSite.siteid)}
                            //   onChange={this.onChange.bind(this)}
                            //   invalid={!this.state.validation.title}
                            />
                          </InputGroup>
                          </Col>
                      </FormGroup>

                      <FormGroup className="row">
                        <Label
                          className="form-control-label"
                          htmlFor="example-text-input"
                          md="1"
                        >
                          Listing Text
                        </Label>
                        <Col md="9">
                          <Input
                            placeholder="Insert listing text for category pages"
                            name="listingText"
                            type="textarea"
                            rows="3"
                            defaultValue={linkedSite.value.listingText || ""}
                            onChange={(e) => changeParams(e, linkedSite.siteid)}
                          />
                          </Col>
                      </FormGroup>

                        </CardBody>
                      </Card>
                      </div>
                    )
                   
                }

            )}
            <FormGroup className="row">
                        <Col md="12" className=" text-right">
                        <Button
                              className="my-0"
                              color="btn btn-outline-default"
                              to="/admin/globalproducts"
                              tag={Link}
                            >
                              Back To Products
                            </Button>
                        <Button
                              className="my-4"
                              color="btn btn-outline-primary"
                              type="submit"
                            //   onClick={this.onClickUpdate.bind(this)}
                            onClick={updateLinkedSites}
                            >
                              Update
                            </Button>
                        </Col>
                      </FormGroup>
            </Col>
          
        </Row>
         
      </>
    );
  } else if (Product.linked && Product.linked.length === 0) {
    return (
      <div>
        <h4>THIS PRODUCT IS NOT LINKED TO ANY WEBSITE</h4>
        <FormGroup className="row">
                        <Col md="12" className=" text-right">
                        <Button
                              className="my-0"
                              color="btn btn-outline-default"
                              to="/admin/globalproducts"
                              tag={Link}
                            >
                              Back To Products
                            </Button>
                        <Button
                              className="my-4"
                              color="btn btn-outline-primary"
                              type="submit"
                            //   onClick={this.onClickUpdate.bind(this)}
                            onClick={updateLinkedSites}
                            >
                              Update
                            </Button>
                        </Col>
                      </FormGroup>
      </div>
    );
  } else {
    return <div>ERROR PLEASE CONTACT THE ADMINISTRATOR...</div>;
  }
}

export default LinkedSites;
